export default "__VITE_ASSET__49333b68__"